import React, { useEffect, useState } from "react";
import { BellRing, BellOff, Loader2, Settings2 } from "lucide-react";
import { toast } from "sonner";
import { apiErr } from "../lib/api";
import { pushSupported, currentSub, enablePush, disablePush } from "../lib/push";
import { PushPrefs } from "./PushPrefs";

export function usePushState() {
  const [on, setOn] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    currentSub().then((s) => setOn(!!s && Notification.permission === "granted")).catch(() => {});
  }, []);
  const run = async (fn) => {
    setBusy(true);
    try { await fn(); } catch (e) { toast.error(e.response ? apiErr(e) : e.message); } finally { setBusy(false); }
  };
  const turnOn = () => run(async () => { await enablePush(); setOn(true); toast.success("Phone alerts ON! Kaun se alerts chahiye, wo bhi chun sakte hain."); });
  const turnOff = () => run(async () => { await disablePush(); setOn(false); toast.success("Phone alerts band kar diye"); });
  return { on, busy, turnOn, turnOff, toggle: on ? turnOff : turnOn, supported: pushSupported() };
}

export function PushToggle({ compact = false }) {
  const { on, busy, turnOn, turnOff, supported } = usePushState();
  const [prefs, setPrefs] = useState(false);
  if (!supported) return null;
  const click = () => (on ? setPrefs(true) : turnOn());
  const off = async () => { setPrefs(false); await turnOff(); };
  const Icon = busy ? Loader2 : on ? BellRing : BellOff;
  const dialog = <PushPrefs open={prefs} onOpenChange={setPrefs} onTurnOff={off} />;
  if (compact) {
    return (
      <>
        <button data-testid="push-toggle-btn" onClick={click} disabled={busy} title={on ? "Phone alerts settings" : "Phone alerts ON karein"}
          className={`p-2 transition-colors duration-200 ${on ? "text-gold" : "text-slate-400 hover:text-white"}`}>
          <Icon size={18} className={busy ? "animate-spin" : ""} />
        </button>
        {dialog}
      </>
    );
  }
  return (
    <>
      <button data-testid="push-toggle-btn" onClick={click} disabled={busy}
        className={`flex items-center gap-2 w-full px-3 py-2 mb-1 text-sm transition-colors duration-200 ${on ? "text-gold" : "text-slate-400 hover:text-white"}`}>
        <Icon size={16} className={busy ? "animate-spin" : ""} /> Phone alerts: {on ? "ON" : "OFF"}
        {on && <Settings2 size={14} className="ml-auto opacity-70" />}
      </button>
      {dialog}
    </>
  );
}
